import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import useRouteLeaveGuard from 'Hooks/useRouteLeaveGuard'
import {
  Button,
  MODAL_SIZE_SM,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot
} from 'mailup-web-components'
import { abTestState } from '../recoil/state/abTest'
import { contentScheduledState } from '../../../components/ContentScheduled/recoil/state'

export const ModalConfirmLeave = () => {
  const intl = useIntl()
  const { IsDirty } = useRecoilValue(abTestState)
  const { isDirty: dateIsDirty } = useRecoilValue(contentScheduledState)
  const [prompt, allow, deny] = useRouteLeaveGuard(!IsDirty && !dateIsDirty)

  const handleConfirm = () => {
    allow()
  }

  return (
    <Modal
      data-mu-test='modal-confirm-leave'
      show={prompt}
      onClose={deny}
      showClose
      closeOnOverlayClick
      size={MODAL_SIZE_SM}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.MessageOverview.ConfirmExitTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.MessageOverview.ConfirmExitDescription'
          })}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button kind='neutral' onClick={deny} data-mu-test='button-cancel'>
          {intl.formatMessage({ id: 'Load.MessageOverview.Cancel' })}
        </Button>
        <Button
          kind='danger'
          onClick={handleConfirm}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({ id: 'Load.MessageOverview.Exit' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
